export {
    getRewards,
    getRedeemedData
}


const ORO_GET = (url, headers, params) => {
    headers = {
      "Content-Type": "application/json; charset=UTF-8",
      ...headers,
    };
    params = params ?? {};
  
    const query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
  
    const requestOptions = {
      method: "GET",
      headers: headers,
      credentials: "include",
    };
  
    if (query) url += "?" + query;
  
    return fetch(
      process.env.REACT_APP_API_URL + url,
      requestOptions
    ).then((response) => response.json());
  };
  
  const ORO_POST = (url, headers, params) => {
    headers = {
      "Content-Type": "application/json; charset=UTF-8",
      ...headers,
    };
  
    const requestOptions = {
      method: "POST",
      headers: headers,
      credentials: "include",
      body: JSON.stringify(params),
    };
  
    return fetch(
      process.env.REACT_APP_API_URL + url,
      requestOptions
    ).then((response) => response.json());
  };    

//TODO: once APIs are ready, replace fetch with ORO_GET or ORO_POST accordingly.
function getRewards() {
  return ORO_GET("/ref/activity", { "use-pkey": false }, {});
}

function getRedeemedData() {
  return fetch("/getRedeemData.json", { "use-pkey": false }).then(jsonresp => jsonresp.json());
}